module.exports = __webpack_public_path__ + "static/img/bk_ysfa_icon.png";